import CryptoJS from 'crypto-js';

export function encryptData(data) {
  const secretKey = process.env.VUE_APP_OTP_SECRET_KEY;
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
  return encryptedData;
}